import React from 'react';

import { TableRow, TableCell } from '@mui/material';
import PropTypes from 'prop-types';
import FlexLib from '@flex/lib';

const { getCustomLabel, formatCurrency, formatFeeType } = FlexLib.utils.feeService;

/**
 * @description this is an individual fee text box.
 *
 * NOTE: This component should be returned from a mapper as an array of FeeDisplayRow
 * components. The mapper should iterate through the 'fees' property from the result of a
 * FeeService.getCalculatedFees() invocation.
 *
 * Example:
 * ```
 *  const feeComponents = Object.values(result.fees).map(this.mapFeesToComponents);
 *
 * ```
 *
 * The mapper should taken in a unique key and a fee object as args.
 *
 * Example:
 * ```
 * function  mapFeesToComponents(fee, i) {
 *  return <FeeDisplayRow key={`${fee.name}-${i}`} fee={fee} />;
 * }
 *
 * ```
 *
 * @param {{fee: Fee, feeSettings: DatabaseFeeSettings}} props
 * @returns {React.Component}
 */
const FeeDisplayRow = (props) => {
  /** @type {Fee} } */
  const fee = props.fee;

  /** @type {import('../../../../types/fees').DatabaseFeeSettings} */
  const feeSettings = props.databaseFeeSettings;

  return fee.display ? (
    <TableRow data-cy={fee.name}>
      <TableCell id={`${fee.name}-label`} data-cy={`${fee.name}-label`}>{`${getCustomLabel(
        fee.name,
        feeSettings
      )} (${formatFeeType(fee.type, fee.value.stored, fee.name)})`}</TableCell>
      <TableCell id={`${fee.name}-amount`} data-cy={`${fee.name}-amount`} align="right">
        {formatCurrency(fee.amount)}
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
};

FeeDisplayRow.propTypes = {
  fee: PropTypes.shape({
    name: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['$', '%']).isRequired,
    amount: PropTypes.string.isRequired,
    value: PropTypes.shape({
      stored: PropTypes.string.isRequired,
      calculated: PropTypes.string.isRequired,
    }),
  }).isRequired,
  databaseFeeSettings: PropTypes.object.isRequired,
};
export default FeeDisplayRow;

/**
 * @typedef {import('../../../../types/fees').Fee } Fee
 */
